import React from "react";
import { FaFacebook, FaWhatsapp, FaLinkedin } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="bg-primary py-8">
            <div className="container mx-auto container-padding">
                <div className="text-center">
                    <h3 className="text-2xl font-bold mb-4">
                        GOLDEN EAGLE MANAGEMENT SOLUTION
                    </h3>
                    <p className="mb-4">Contact Us: +94 76 649 6256</p>
                    <div className="flex justify-center space-x-4">
                        <a
                            href="https://www.facebook.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-secondary hover:text-white transition-colors"
                        >
                            <FaFacebook size={24} />
                        </a>
                        <a
                            href="https://wa.me/94766496256"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-secondary hover:text-white transition-colors"
                        >
                            <FaWhatsapp size={24} />
                        </a>
                        <a
                            href="https://www.linkedin.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-secondary hover:text-white transition-colors"
                        >
                            <FaLinkedin size={24} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
